import { SearchableItemModelT } from "@/Common/Models/SearchableItem";
import { BaseOntarioObstetricalFileSubSectionProps } from "@/Patient/Components/MedicalNote/Obstetric/Form/Ontario/Subcomponent/BaseOntarioObstetricalFileSubSection";
import { BaseOntarioObstetricalFileSubLaboratorySection } from "./BaseOntarioObstetricalFileSubLaboratorySection";

class OntarioObstetricalFileInitialLabInvestigations extends BaseOntarioObstetricalFileSubLaboratorySection<BaseOntarioObstetricalFileSubSectionProps, never> {
    public render(): JSX.Element {
        const laboratory = this.props.form.Opr2.InitialLabInvestigations;

        return (
            <div className="col-md-4 border border-left padding-md-bottom">
                <div className="section">
                    {this.renderSubTitle("ObstetricalFile_InitialLaboratoryInvestigationsLabel")}
                    <div className="row margin-xs-bottom">
                        {this.renderLaboratoryTextField(
                            "HemoglobinAbbreviationLabel",
                            laboratory.Hemoglobin,
                            value => this.props.mutateModelState(s => s.Opr2.InitialLabInvestigations.Hemoglobin = value),
                            true
                        )}
                        {this.renderLaboratoryTextField(
                            "HepatitisBSurfaceAntigenAbbrevLabel",
                            laboratory.HepatitisBSurfaceAntigenHBsAg,
                            value => this.props.mutateModelState(s => s.Opr2.InitialLabInvestigations.HepatitisBSurfaceAntigenHBsAg = value),
                            true
                        )}
                    </div>
                    <div className="row margin-xs-bottom">
                        <div className="col-md-6 flex-display">
                            {this.renderSimpleField(
                                "BloodGroupAcronymLabel",
                                this.controlRenderer.renderComboBox({
                                    id: "bloodGroup-initialLab",
                                    selectedCode: laboratory.BloodGroup,
                                    items: this.controlRenderer.getBloodGroupOptions(),
                                    onChange: bloodGroup => this.setBloodGroup(bloodGroup),
                                    hasEmptyItem: true
                                }),
                                "flex-column margin-sm-right flex-grow-1"
                            )}
                            {this.renderSimpleField(
                                "BloodRhesusAcronymLabel",
                                this.controlRenderer.renderComboBox({
                                    id: "bloodRhesus-initialLab",
                                    selectedCode: laboratory.BloodRhesus,
                                    items: this.controlRenderer.getBloodRhesusOptions(),
                                    onChange: bloodRhesus => this.setBloodRhesus(bloodRhesus),
                                    hasEmptyItem: true
                                }),
                                "flex-column flex-grow-1"
                            )}
                        </div>
                        {this.renderSimpleField(
                            "SyphilisLabel",
                            this.controlRenderer.renderAutoCompleteTextbox({
                                value: laboratory.Syphilis,
                                autoCompleteItems: this.getReactivityOptions(),
                                onChange: syphilis => this.props.mutateModelState(s => s.Opr2.InitialLabInvestigations.Syphilis = syphilis),
                                onAutoCompleteSelected: (code, _, value) => this.props.mutateModelState(s => s.Opr2.InitialLabInvestigations.Syphilis = value),
                                maxLength: 17,
                                disableMatchAutoSorting: true
                            }),
                            "flex-column col-md-6"
                        )}
                    </div>
                    <div className="row margin-xs-bottom">
                        {this.renderLaboratoryTextField(
                            "MeanCorpuscularVolumeAbbreviationLabel",
                            laboratory.MeanCorpuscularVolume,
                            value => this.props.mutateModelState(s => s.Opr2.InitialLabInvestigations.MeanCorpuscularVolume = value),
                            true
                        )}
                        {this.renderLaboratoryTextField(
                            "HumanImmunodeficiencyVirusAbbreviationLabel",
                            laboratory.HumanImmunodeficiencyVirus,
                            value => this.props.mutateModelState(s => s.Opr2.InitialLabInvestigations.HumanImmunodeficiencyVirus = value),
                            true
                        )}
                    </div>
                    <div className="row margin-xs-bottom">
                        {this.renderLaboratoryTextField(
                            "AntibodyScreenLabel",
                            laboratory.AntibodyScreen,
                            antibodyScreen => this.props.mutateModelState(s => s.Opr2.InitialLabInvestigations.AntibodyScreen = antibodyScreen),
                            true
                        )}
                        {this.renderLaboratoryTextField(
                            "GeneralConditionGonorrheasAbbreviationLabel",
                            laboratory.GeneralConditionGonorrheas,
                            value => this.props.mutateModelState(s => s.Opr2.InitialLabInvestigations.GeneralConditionGonorrheas = value),
                            true
                        )}
                    </div>
                    <div className="row margin-xs-bottom">
                        {this.renderLaboratoryTextField(
                            "PlateletsLabel",
                            laboratory.Platelets,
                            value => this.props.mutateModelState(s => s.Opr2.InitialLabInvestigations.Platelets = value)
                        )}
                        {this.renderLaboratoryTextField(
                            "Chlamydia",
                            laboratory.Chlamydia,
                            value => this.props.mutateModelState(s => s.Opr2.InitialLabInvestigations.Chlamydia = value),
                            true
                        )}
                    </div>
                    <div className="row">

                        {this.renderSimpleField(
                            "RubellaImmuneLabel",
                            this.controlRenderer.renderAutoCompleteTextbox({
                                value: laboratory.RubellaImmune,
                                autoCompleteItems: this.getRubellaImmuneptions(),
                                onChange: rubellaImmune => this.props.mutateModelState(s => s.Opr2.InitialLabInvestigations.RubellaImmune = rubellaImmune),
                                onAutoCompleteSelected: (code, _, value) => this.props.mutateModelStateWithFormUpdate(s => s.Opr2.InitialLabInvestigations.RubellaImmune = value),
                                maxLength: 17,
                                disableMatchAutoSorting: true
                            }),
                            "flex-column col-md-6"
                        )}

                        {this.renderSimpleField(
                            "UrineCSLabel",
                            this.controlRenderer.renderAutoCompleteTextbox({
                                value: laboratory.UrineCS,
                                autoCompleteItems: this.getUrineCSOptions(),
                                onChange: urineCS => this.props.mutateModelState(s => s.Opr2.InitialLabInvestigations.UrineCS = urineCS),
                                onAutoCompleteSelected: (code, _, value) => this.props.mutateModelState(s => s.Opr2.InitialLabInvestigations.UrineCS = value),
                                maxLength: 17,
                                disableMatchAutoSorting: true
                            }),
                            "flex-column col-md-6"
                        )}
                    </div>
                </div>
            </div>
        );
    }

    private getReactivityOptions(): SearchableItemModelT<string>[] {
        return [
            new SearchableItemModelT("Reactive", "Reactivity_Reactive"),
            new SearchableItemModelT("Non-reactive", "Reactivity_NonReactive")
        ];
    }

    private getUrineCSOptions(): SearchableItemModelT<string>[] {
        return [
            new SearchableItemModelT(this.getString("NegativeLabel"), "UrineCSO_Negative"),
            new SearchableItemModelT(this.getString("Positive"), "UrineCSO_Positive"),
            new SearchableItemModelT(this.getString("MixedFloraLabel"), "UrineCSO_MixedFlora"),
            new SearchableItemModelT(this.getString("ContaminatedLabel"), "UrineCSO_Contaminated")
        ];
    }

    private getRubellaImmuneptions(): SearchableItemModelT<string>[] {
        return [
            new SearchableItemModelT(this.getString("ImmuneLabel"), "Immune"),
            new SearchableItemModelT(this.getString("NotImmuneLabel"), "Not Immune"),
            new SearchableItemModelT(this.getString("IndeterminateLabel"), "Indeterminate")
        ];
    }
}

export { OntarioObstetricalFileInitialLabInvestigations };
